import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
import { SMA } from "../moving_averages/SMA";
import LinkedList from "../Utils/FixedSizeLinkedList";
export var CCIInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(CCIInput, _IndicatorInput);

  function CCIInput() {
    _classCallCheck(this, CCIInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(CCIInput).apply(this, arguments));
  }

  return CCIInput;
}(IndicatorInput);
export var CCI =
/*#__PURE__*/
function (_Indicator) {
  _inherits(CCI, _Indicator);

  function CCI(input) {
    var _this;

    _classCallCheck(this, CCI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CCI).call(this, input));
    var lows = input.low;
    var highs = input.high;
    var closes = input.close;
    var period = input.period;
    var format = _this.format;
    var constant = .015;
    var currentTpSet = new LinkedList(period);
    var tpSMACalculator = new SMA({
      period: period,
      values: [],
      format: function format(v) {
        return v;
      }
    });

    if (!(lows.length === highs.length && highs.length === closes.length)) {
      throw new Error("Inputs(low,high, close) not of equal size");
    }

    _this.result = [];
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var tick, tp, smaTp, meanDeviation, _cci, sum, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, x;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return;

            case 2:
              tick = _context.sent;

            case 3:
              if (!true) {
                _context.next = 37;
                break;
              }

              tp = (tick.high + tick.low + tick.close) / 3;
              currentTpSet.push(tp);
              smaTp = tpSMACalculator.nextValue(tp);
              meanDeviation = null;
              _cci = void 0;
              sum = 0;

              if (!(smaTp !== undefined)) {
                _context.next = 32;
                break;
              }

              // First, subtract the most recent 20-period average of the typical price from each period's typical price.
              // Second, take the absolute values of these numbers.
              // Third,sum the absolute values.
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 14;

              for (_iterator = currentTpSet.iterator()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                x = _step.value;
                sum = sum + Math.abs(x - smaTp);
              } // Fourth, divide by the total number of periods (20).


              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](14);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 22:
              _context.prev = 22;
              _context.prev = 23;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 25:
              _context.prev = 25;

              if (!_didIteratorError) {
                _context.next = 28;
                break;
              }

              throw _iteratorError;

            case 28:
              return _context.finish(25);

            case 29:
              return _context.finish(22);

            case 30:
              meanDeviation = sum / period;
              _cci = (tp - smaTp) / (constant * meanDeviation);

            case 32:
              _context.next = 34;
              return _cci;

            case 34:
              tick = _context.sent;
              _context.next = 3;
              break;

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[14, 18, 22, 30], [23,, 25, 29]]);
    })();

    _this.generator.next();

    lows.forEach(function (tick, index) {
      var result = _this.generator.next({
        high: highs[index],
        low: lows[index],
        close: closes[index]
      });

      if (result.value !== undefined) {
        _this.result.push(result.value);
      }
    });
    return _this;
  }

  _createClass(CCI, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price).value;

      if (result !== undefined) {
        return result;
      }
    }
  }]);

  return CCI;
}(Indicator);
CCI.calculate = cci;
export function cci(input) {
  Indicator.reverseInputs(input);
  var result = new CCI(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}